<template>
  <div id="app" :class="{ 'we-chat': isInWechat }">
    <keep-alive>
      <router-view v-if="this.$route.meta.keepAlive" />
      <!--这里是会被缓存的组件-->
    </keep-alive>
    <router-view v-if="!this.$route.meta.keepAlive" />
  </div>
</template>

<script>
import { SEARCH_HISTORY_STORAGE_KEY } from '@/store/plugins/persistSearchHistoryPlugin';
import getPlatformGeneral from '@/utils/get-platform';
import { mapState } from 'vuex';

const wx = require('weixin-js-sdk');

export default {
  data() {
    return {
      isInWechat: false,
    };
  },
  computed: {
    ...mapState('publicStore', ['platform']),
  },
  created() {
    // 页面刷新时 从 localStorage 中取出历史记录赋值到 vuex
    const historyListString = localStorage.getItem(SEARCH_HISTORY_STORAGE_KEY);
    if (historyListString) {
      const historyList = JSON.parse(historyListString);
      this.$store.commit('searchHistory/SET_HISTORY_LIST', historyList);
    }
    if (this.$route.query.mini_from === 'healthy_mall') {
      sessionStorage.setItem('mini_from', 'healthy_mall');
    }
    getPlatformGeneral().then(res => {
      this.$store.commit('publicStore/SET_PLATFORM', res);
      console.log(this.platform);
    });
    wx.miniProgram.getEnv(wxres => {
      if (wxres.miniprogram) {
        this.isInWechat = true;
      }
    });
  },
};
</script>
<style scoped lang="scss">
.we-chat {
  padding-bottom: 120px;
}
</style>
